/* eslint-disable no-param-reassign */
/* eslint-disable key-spacing */
/* eslint-disable comma-dangle */
/* eslint-disable no-unused-vars */
import {
  FETCH_STICK_PRICE,
  FETCH_STICK_PRICE_SUCCEED,
  FETCH_STICK_PRICE_FAILED,
  FETCH_LATEST_PRICE,
  FETCH_LATEST_PRICE_SUCCEED,
  FETCH_LATEST_PRICE_FAILED,
  FETCH_PRICE_24H,
  FETCH_PRICE_24H_SUCCEED,
  FETCH_PRICE_24H_FAILED,
  FETCH_ALL_LATEST_PRICE,
  FETCH_ALL_LATEST_PRICE_SUCCEED,
  FETCH_ALL_LATEST_PRICE_FAILED,
  FETCH_PRICE_MARKET_24H,
  FETCH_PRICE_MARKET_24H_SUCCEED
} from '../actions/price/action_types';

export default (state = {
  latestPrices: [],
  allLatestPrices: [],
  stickPrices: [],
  price24h: {},
  isTableLoading: false,
  currencyLightChart: [],
}, action) => {
  switch (action.type) {
    case FETCH_STICK_PRICE:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_STICK_PRICE_SUCCEED:
      window._.forEach(action.params.data, (item) => {
        item.date = new Date(item.created_at / 1000);
      });

      return {
        ...state,
        stickPrices: action.params.data,
        isTableLoading: false,
      };
    case FETCH_STICK_PRICE_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    case FETCH_LATEST_PRICE:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_LATEST_PRICE_SUCCEED:
      return {
        ...state,
        latestPrices: action.params.data,
        isTableLoading: false,
      };
    case FETCH_LATEST_PRICE_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    case FETCH_PRICE_24H:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_PRICE_24H_SUCCEED:
      return {
        ...state,
        price24h: action.params.data,
        isTableLoading: false,
      };
    case FETCH_PRICE_24H_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    case FETCH_ALL_LATEST_PRICE:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_ALL_LATEST_PRICE_SUCCEED:
      return {
        ...state,
        allLatestPrices: action.params.data,
        isTableLoading: false,
      };
    case FETCH_ALL_LATEST_PRICE_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    case FETCH_PRICE_MARKET_24H_SUCCEED:
      return {
        ...state,
        currencyLightChart: action.params.data,
      };
    default:
      return {
        ...state,
      };
  }
};
